const MAX_CONCURRENT_PREFETCH = 2;
let prefetchAbortController = null;
let requestQueue = [];
let isProcessing = false;

const runWithConcurrencyLimit = async (fns, signal, limit) => {
  for (let i = 0; i < fns.length; i += limit) {
    if (signal.aborted) return;
    const batch = fns.slice(i, i + limit);
    await Promise.all(batch.map(fn => fn().catch(() => null)));
  }
};

const processQueue = async () => {
  if (isProcessing || requestQueue.length === 0) return;
  isProcessing = true;
  try {
    while (requestQueue.length > 0) {
      const { fns, signal } = requestQueue.shift();
      if (signal.aborted) continue;
      await runWithConcurrencyLimit(fns, signal, MAX_CONCURRENT_PREFETCH);
    }
  } finally {
    isProcessing = false;
  }
};

export const requestPriorityManager = {
  enqueuePrefetchBatch: (asyncFns, priority = 'low') => {
    const signal = (prefetchAbortController = new AbortController()).signal;

    if (priority === 'high') {
      requestQueue.unshift({ fns: asyncFns, signal });
    } else {
      requestQueue.push({ fns: asyncFns, signal });
    }

    return processQueue();
  },

  abortPrefetch: () => {
    prefetchAbortController?.abort();
    prefetchAbortController = null;
    requestQueue = [];
  }
};
